import { render, staticRenderFns } from "./LineageManager.vue?vue&type=template&id=a45545f2&scoped=true"
import script from "./LineageManager.vue?vue&type=script&lang=js"
export * from "./LineageManager.vue?vue&type=script&lang=js"
import style0 from "./LineageManager.vue?vue&type=style&index=0&id=a45545f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45545f2",
  null
  
)

export default component.exports